<script lang="ts">
	import { menuOpen } from '$lib/helpers/app.stores';
	import { PrismicLink } from '@prismicio/svelte';
	import PrimaryLogo from './PrimaryLogo.svelte';
	import { page } from '$app/state';
	import { onDestroy } from 'svelte';

	const { navigation } = $props();

	let isMenuOpen: boolean = $state(false);

	const menuOpenSubscription = menuOpen.subscribe((value) => {
		isMenuOpen = value;
	});

	const toggleMenu = (e: MouseEvent) => {
		e.preventDefault();
		isMenuOpen = !isMenuOpen;
		menuOpen.set(isMenuOpen);
	};

	onDestroy(() => {
		menuOpenSubscription();
	});
</script>

<nav class="global-navigation">
	<div class="d-flex align-items-stretch justify-content-between justify-content-lg-start">
		<a href="/" class="global-navigation__logo" title="Cardiff Eagles Ice Hockey Club">
			<PrimaryLogo />
		</a>

		{#if navigation.data.links.length}
			<ul class="global-navigation__nav" class:open={isMenuOpen}>
				{#each navigation.data.links as link}
					<li class="global-navigation__nav--item">
						<PrismicLink
							field={link}
							class={page.url.pathname.startsWith(link.url)
								? 'global-navigation__nav--link active'
								: 'global-navigation__nav--link'}
						/>
					</li>
				{/each}
			</ul>
		{/if}

		<button
			class="global-navigation__toggle"
			onclick={toggleMenu}
			class:open={isMenuOpen}
			title="Menu"
		>
			<span></span>
			<span></span>
			<span></span>
		</button>
	</div>
</nav>
